import { applyFilters, doRequest } from "./helpers";

export default class MetaCampaignService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/campaigns`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }

  static async linkCrmCampaign(accountId, metaCampaignId, crmCampaignId) {
    return doRequest(
      "PUT",
      `/meta_ad_account/${accountId}/campaigns/${metaCampaignId}/crm_campaign`,
      { data: { crm_campaign_id: crmCampaignId } }
    );
  }
}
